const collectionScrollStateKey = 'aveyCollectionScroll';

const rememberCollectionScroll = (link) => {
  if (!link || link.target === '_blank' || link.hasAttribute('download')) return;

  const destination = new URL(link.href, window.location.href);
  if (destination.origin !== window.location.origin || !destination.pathname.includes('/products/')) return;

  history.replaceState(
    {
      ...(history.state || {}),
      [collectionScrollStateKey]: {
        path: `${window.location.pathname}${window.location.search}`,
        y: window.scrollY,
      },
    },
    '',
    window.location.href,
  );
};

const restoreCollectionScroll = (event) => {
  const saved = history.state?.[collectionScrollStateKey];
  const navigation = performance.getEntriesByType?.('navigation')?.[0];
  const isHistoryNavigation = event.persisted || navigation?.type === 'back_forward';
  const currentPath = `${window.location.pathname}${window.location.search}`;

  if (!isHistoryNavigation || saved?.path !== currentPath || !Number.isFinite(saved.y)) return;

  // Two frames let the collection grid finish its first layout without adding a visible delay.
  requestAnimationFrame(() => requestAnimationFrame(() => window.scrollTo(0, saved.y)));
};

document.addEventListener('click', (event) => {
  rememberCollectionScroll(event.target.closest('[data-collection-card] a[href]'));
}, { capture: true });

window.addEventListener('pageshow', restoreCollectionScroll);

document.querySelectorAll('[data-collection-card]').forEach((card) => {
  const form = card.querySelector('[data-collection-product-form]');
  const select = card.querySelector('[data-collection-variant]');
  const price = card.querySelector('[data-collection-price]');

  select?.addEventListener('change', () => {
    const option = select.selectedOptions[0];
    if (price && option?.dataset.price) price.textContent = option.dataset.price;
    const quantity = form?.querySelector('input[name="quantity"][type="number"]');
    if (quantity && option?.dataset.quantityMin) {
      quantity.min = option.dataset.quantityMin;
      quantity.step = option.dataset.quantityStep;
      if (option.dataset.quantityMax) quantity.max = option.dataset.quantityMax;
      else quantity.removeAttribute('max');
      quantity.value = quantity.min;
      quantity.closest('avey-pro-quantity')?.refresh();
    }
    const visual = select.closest('[data-shade-select]')?.querySelector('[data-shade-select-visual]');
    if (visual && option) {
      const image = option.dataset.shadeImage || '';
      visual.classList.toggle('avey-shade-select__visual--fallback', !image);
      visual.style.setProperty('--avey-shade-image', image ? `url("${image}")` : 'none');
    }
  });

  form?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (!button || button.disabled) return;
    button.disabled = true;
    const attribution = window.AveyBottleExperiment?.properties() || {};
    Object.entries(attribution).forEach(([key, value]) => {
      let input = form.querySelector(`input[name="properties[${key}]"]`);
      if (!input) { input = document.createElement('input'); input.type = 'hidden'; input.name = `properties[${key}]`; form.append(input); }
      input.value = value;
    });
    try {
      const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message);
      document.dispatchEvent(new CustomEvent('avey:cart:added', { detail: { opener: button } }));
    } catch (error) {
      form.submit();
    } finally {
      button.disabled = false;
    }
  });
});
